import { useContext } from "react";
import FetchUserContext from "../contexts/FetchUserInformation";

function useFetchUserContext(){
    return useContext(FetchUserContext);
}

export default useFetchUserContext;